import { render, staticRenderFns } from "./Dispatcher.vue?vue&type=template&id=f193f61e&scoped=true&"
import script from "./Dispatcher.vue?vue&type=script&lang=js&"
export * from "./Dispatcher.vue?vue&type=script&lang=js&"
import style0 from "./Dispatcher.vue?vue&type=style&index=0&id=f193f61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f193f61e",
  null
  
)

export default component.exports